<template>
    <div class="container-2fa">
        <!--  <header>
            <img src="@/assets/images/logo-tecmor.jpg" alt="">
        </header> -->

        <div class="container-cards">
            <div class="title-2fa">Sistema de Gestión y Cobranza de Cartera Vencida</div>

            <v-card width="700px" :elevation="8">
                <div class="pa-8">
                    <div class="text-center">
                        <img src="@/assets/images/two-factor-authentication.png" alt="Login" class="icon-2fa">
                    </div>
                    <div class="title">Autenticación en 2 Pasos</div>
                    <div class="text-h6 text-center mb-4">
                        Ingresa el código generado por la aplicación
                    </div>
                    <div class="text-h7 text-center mb-4 text-red">
                        *Si requires recuperar tu acceso a Google Authenticator, contacta a un Administrador.
                    </div>
                    <v-otp-input
                        id="otp-input"
                        name="otp-input"
                        :loading="validatingCode"
                        v-model="otpValue"
                    ></v-otp-input>
                    <v-row justify="center" class="mt-2">
                        <v-btn class="btn-2fa" @click="validateCode()" :disabled="validatingCode || !/^[0-9]{6}$/.test(otpValue)">Validar Código</v-btn>
                    </v-row>
                </div>
                <v-card-actions class="d-flex justify-space-between">
                    <v-btn @click="logout()">
                        <img src="@/assets/images/item-menu-cerrar-sesion.png" alt="Cerrar Sesión"
                            style="width: 24px; height: 24px;">
                        Cerrar Sesión
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
        <Footer />
    </div>
    <Footer class="content_footer" :elevation="10" />
</template>
<script>
import Footer from '../../components/Footer.vue'
import { LoginService } from '@/services/LoginService'
import { useAuthStore } from '@/stores/auth'

export default {
    name: "Validate2FA",
    components: {
        Footer,
    },
    data() {
        return {
            validatingCode: false,
            otpValue: '',
            qrCode: ''
        }
    },
    methods: {
        async validateCode() {
            const authStore = useAuthStore();
            this.validatingCode = true;
            try {
                const response = await LoginService.validate2FA(this.otpValue);
                if (response && !response.error) {
                    // Navigate to the main application page
                    authStore.setTwoFAStatus('VALIDATED');
                    localStorage.setItem('TOKEN', response.response.token);
                    this.$router.push('/SGCCV');
                }
            } catch (error) {
                console.error('Error validating 2FA code:', error);
                // Handle validation error (e.g., show error message)
            } finally {
                this.validatingCode = false;
            }
        },
        logout() {
            const authStore = useAuthStore();
            authStore.logout();
            // Clear any stored tokens or session data here
            this.$router.push('/login');
        }
    }
}
</script>
<style scoped>
.container-2fa {
    height: 100vh;
    background-image: url("@/assets/images/background.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.title-2fa {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.2;
    font-size: 25pt;
    font-weight: 400;
    padding-bottom: 20px;
}

.image-title-2fa {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    display: block;
    text-align: center;
    width: 100%;
    font-size: 15pt;
}

.container-cards {
    padding-left: 15%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 95vh;
}

.icon-2fa {
    height: 60px;
}

.title {
    text-align: center;
    font-size: 30px;
}

form {
    margin: 30px 0 10px 0;
}

.btn-2fa {
    background-color: #007BFF;
    color: #FFFFFF;
}

footer {
    height: 5vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading {
    text-align: center;
}
</style>